import React from "react";
import styled, { css } from "styled-components";
import Portal from "../common/Portal";
import { Div } from "../utils";
import { useOverlay } from "../utils/hooks";
import { SvgLeft } from "../Svgs/Left";

const BackIcon = styled(SvgLeft)(
  ({ theme: { colors, css: c } }) => css`
    color: ${colors.black60};
  `
);

const Container = styled(Div)(
  ({ theme: { colors } }) => css`
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    position: fixed;
    background: ${colors.white};
    padding: 16px 18px;
    z-index: 1000;
  `
);

const Body = styled(Div)`
  height: calc(100vh - 78px);
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  children: JSX.Element;
};
export const FullscreenModal = ({ isOpen, onClose, children }: Props) => {
  useOverlay(isOpen);
  Math.random().toString(36).substring(2);
  return (
    <>
      {isOpen && (
        <Portal>
          <Container>
            <Div clickable onClick={onClose} h={30} alignCenter mb={16}>
              <BackIcon />
            </Div>
            <Body>{children}</Body>
          </Container>
        </Portal>
      )}
    </>
  );
};
